import { render, staticRenderFns } from "./TipoEndereco.vue?vue&type=template&id=b85dd7e8"
import script from "./TipoEndereco.vue?vue&type=script&lang=js"
export * from "./TipoEndereco.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports